const filterList = ["SupplierName", "Platform", "Qty", "SettleAmount", "Kilometre", "KPrice", "Price"]

const columns = [
	{
		"title": "供应商名称",
		"dataIndex": "SupplierName",
		"key": "SupplierName",
		"width": "14%",
		"align": "center",
		"scopedSlots": {
			"customRender": "SupplierName"
		}
	}, {
		"title": "供应商性质",
		"dataIndex": "Platform",
		"key": "Platform",
		"sorter": true,
		"width": "14%",
		"align": "center",
		"scopedSlots": {
			"customRender": "Platform"
		}
	}, {
		"title": "订单量",
		"dataIndex": "Qty",
		"key": "Qty",
		"sorter": true,
		"width": "14%",
		"align": "center",
		"scopedSlots": {
			"customRender": "Qty"
		}
	}, {
		"title": "总金额",
		"dataIndex": "SettleAmount",
		"key": "SettleAmount",
		"sorter": true,
		"width": "14%",
		"align": "center",
		"scopedSlots": {
			"customRender": "SettleAmount"
		}
	}, {
		"title": "公里数",
		"dataIndex": "Kilometre",
		"key": "Kilometre",
		"sorter": true,
		"width": "14%",
		"align": "center",
		"scopedSlots": {
			"customRender": "Kilometre"
		}
	}, {
		"title": "均公里价",
		"dataIndex": "KPrice",
		"key": "KPrice",
		"sorter": true,
		"width": "14%",
		"align": "center",
		"scopedSlots": {
			"customRender": "KPrice"
		}
	}, {
		"title": "均单价",
		"dataIndex": "Price",
		"key": "Price",
		"sorter": true,
		"align": "center",
		"scopedSlots": {
			"customRender": "Price"
		}
	}
]

export {
	filterList,
	columns
}
